import React from 'react'
import { Icon } from '@fluentui/react/lib/Icon'
import { /* ChevronLeft,  */ChevronRight, MoreVertical } from 'react-feather';
import { UserAvatar, ActionPopup } from '../../../components';

const Edit = () => <Icon iconName="Edit" className="ms-Edit text-xl" />;
const Delete = () => <Icon iconName="Delete" className="ms-Delete text-xl" />;

const data = [
  {
    title: {
      english: 'veniam consequat sunt nostrud amet',
      indonesia: 'Sunt nostrud amet',
    },
    excerpt: {
      english: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit.',
      indonesia: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit.',
    },
    image: '/images/khub_event_detail.jpg'
  },
  {
    title: {
      english: 'veniam consequat sunt nostrud amet',
      indonesia: 'Sunt nostrud amet',
    },
    excerpt: {
      english: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit.',
      indonesia: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit.',
    },
    image: '/images/khub_event_detail.jpg'
  },
  {
    title: {
      english: 'veniam consequat sunt nostrud amet',
      indonesia: 'Sunt nostrud amet',
    },
    excerpt: {
      english: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit.',
      indonesia: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit.',
    },
    image: '/images/khub_event_detail.jpg'
  },
  {
    title: {
      english: 'veniam consequat sunt nostrud amet',
      indonesia: 'Sunt nostrud amet',
    },
    excerpt: {
      english: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit.',
      indonesia: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit.',
    },
    image: '/images/khub_event_detail.jpg'
  },
]

const LocationRow = ({data, onEdit}) => {
  const [open, setOpen] = React.useState(false)
  const [popedUp, setPopedUp] = React.useState(false)

  const actionButtonClasses = "cursor-pointer text-sm text-white h-full flex flex-col items-center justify-center py-5"
  const actionButtonStyles = {
    minWidth: '67px'
  }

  return (
    <tr className="text-sm text-gray-444 location-row">
      <td className="align-top">
        <UserAvatar size="79px" image={data.image}/>
      </td>
      <td className="align-top">
        {/* Desktop */}
        <div className="hidden lg:block">
          <div className="mb-3">
            <div className="text-gray-999 text-xs">English</div>
            <p className="text-sm"><strong>{data.title.english}</strong></p>
            <p className="text-sm text-gray-444">{data.excerpt.english}</p>
          </div>
          <div className="">
            <div className="text-gray-999 text-xs">Indonesia</div>
            <p className="text-sm"><strong>{data.title.indonesia}</strong></p>
            <p className="text-sm text-gray-444">{data.excerpt.indonesia}</p>
          </div>
        </div>

        {/* Mobile */}
        <div className="lg:hidden">
          <p className="text-sm mb-4"><strong>{data.title.english}</strong></p>
          <p className="text-sm text-gray-444">{data.excerpt.english}</p>
        </div>
      </td>
      <td className="relative align-top">
        <div className="hidden lg:flex items-center">
          <p className="cursor-pointer underline text-xs text-gray-999 mr-2" onClick={onEdit}>Edit</p>
          <p className="cursor-pointer underline text-xs text-gray-999">Delete</p>
        </div>
        <MoreVertical className="ml-auto lg:hidden text-gray-999" onClick={() => setPopedUp(true)} />
        {
          popedUp &&
          <ActionPopup handleClose={() => setPopedUp(false)} onEdit={onEdit}/>
        }

        {/* Backup */}
        {/* <ChevronLeft className="lg:hidden" onClick={() => setOpen(true)}/> */}
        {
          open &&
          <div className="flex items-center absolute top-0 right-0 h-full">
            <div
              className="h-full flex items-center justify-end pr-4"
              style={{width: '183px', background: 'linear-gradient(270deg, #FFFFFF 27.22%, rgba(255, 255, 255, 0) 95.83%)'}}
              onClick={() => setOpen(false)}
            >
              <ChevronRight />
            </div>
            <div
              className={`bg-primary ${actionButtonClasses}`}
              style={{...actionButtonStyles}}
              onClick={onEdit}
            >
              <Edit/>
              <p className="underline mt-2">Edit</p>
            </div>
            <div
              className={`${actionButtonClasses}`}
              style={{background: '#999', ...actionButtonStyles}}
            >
              <Delete/>
              <p className="underline mt-2">Delete</p>
            </div>
          </div>
        }
      </td>
    </tr>
  )
}

const JourneyTable = ({onEdit}) => {
  return (
    <table className="table table--striped mb-8 lg:mb-0">
      <tbody>
        {
          data.map((d, index) => (
            <LocationRow key={index} data={d} onEdit={onEdit} />
          ))
        }
      </tbody>
    </table>
  )
}

export { JourneyTable }